<template>
  <div id="app">
    <!-- 缓存的路由组件 -->
    <keep-alive>
      <router-view v-if="$route.meta && $route.meta.keepAlive" />
    </keep-alive>

    <!-- 不缓存的路由组件 -->
    <router-view v-if="!($route.meta && $route.meta.keepAlive)" />
  </div>
</template>

<script>
import { setI18nLanguage } from '@/lang/index.js'
export default {
  methods: {
    // 设置语言
    languageSelection() {
      // setI18nLanguage('it')
      if (this.$client.getAppInfoLang() == 'ar') {
        setI18nLanguage('ar')
      }
    },
    // 设置title ico
    setHtmlHead() {
      let name = 'Vava - Live video chat'
      let ico = '/ico/ico-vava.png'

      let domainName = window.location.hostname

      // vava
      if (this.domainNameFlag('vava', domainName)) {
        name = 'Vava - Live video chat'
        ico = '/ico/ico-vava.png'
      }

      // echo
      if (this.domainNameFlag('echo', domainName)) {
        name = 'Echo'
        ico = '/ico/ico-echo.png'
      }
      // joychat
      if (this.domainNameFlag('joychat', domainName)) {
        name = 'Joychat'
        ico = '/ico/ico-joychat.png'
      }
      // kiko
      if (this.domainNameFlag('kiko', domainName)) {
        name = 'Kiko'
        ico = '/ico/ico-kiko.png'
      }
      // joylink
      if (this.domainNameFlag('joylink', domainName)) {
        name = 'Joylink'
        ico = '/ico/ico-joylink.png'
      }
      // goparty
      if (this.domainNameFlag('goparty', domainName)) {
        name = 'Goparty'
        ico = '/ico/ico-goparty.png'
      }

      document.getElementsByTagName('title')[0].innerText = name

      const link = document.querySelector("link[rel*='icon']") || document.createElement('link')
      link.href = ico
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  },
  mounted() {
    // 设置语言
    this.languageSelection()

    // 设置title ico
    this.setHtmlHead()
  }
}
</script>

<style lang="less">
.custom-nav-block {
  position: sticky;
  top: 0px;
  z-index: 999;
  background-color: #ffffff;
}

.van-nav-bar {
  background-color: transparent;
}

.van-hairline--bottom::after {
  border-bottom-width: 0px !important;
}

.van-bar .left-nav,
.van-bar .right-nav {
  width: 24px;
  height: 24px;

  font-size: 17px !important;
  font-family: Inter-Bold, Inter;
  font-weight: bold;
  color: #333333;
}

.van-bar .left-nav {
  margin-right: 6px;
}

.van-popover__action {
  width: calc(100vw / 2) !important;
  height: auto !important;
  padding: 8px;
}

.van-nav-bar__title {
  color: #fff;
  font-family: F-Medium;
}

.van-nav-bar__left .tit-left {
  font-size: 17px;
  font-family: Inter;
  font-weight: bold;
  color: #333333;
}

::v-deep input::-webkit-input-placeholder {
  color: #d8d8d8;
}

.ar-style {
  * {
    direction: rtl;
  }
  .right-read {
    direction: rtl !important;
    .ar-arrow {
      transform: rotateY(180deg);
    }
  }
  .right-align {
    text-align: right !important;
  }
  .custom-nav-block {
    .van-nav-bar__left {
      direction: rtl;
      right: 0;
      left: auto;
      img {
        transform: rotateY(180deg);
      }
    }
    .van-nav-bar__right {
      direction: rtl;
      left: 0;
      right: auto;
    }
  }
}

html[lang='ar'] {
  .van-bar .left-nav {
    margin-right: 0;
    margin-left: 6px;
  }
}
</style>
